import { I18n } from "../types";
import { FormField } from '@hilma/netina2all';


export const profilePersonalDetailsFields: FormField<I18n>[] = [
	{
		description: i18n => i18n.pSum.name,
		id: 'fullName',
		required: true
	},
	{
		description: i18n => i18n.pSum.phone,
		id: 'phone',
		required: false,
		readonly: true
	},
];